
import 'components/ckeditor.tag'
import 'components/loader.tag'
import 'pages/images/image-select.tag'
import 'pages/products/products/product-edit-additional-categories.tag'
import 'pages/products/products/product-edit-discounts.tag'
import 'pages/products/groups/filters-select-modal.tag'
import parallel from 'async/parallel'
riot.tag2('group-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/categories"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isMulti}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isMulti ? \'Мультиредактирование категорий\' : item.name || \'Редактирование категории\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="{active: !isMulti}" if="{!isMulti}"><a data-toggle="tab" href="#group-edit-home">Основная информация</a></li>\n      <li if="{!isMulti}"><a data-toggle="tab" href="#group-edit-similar">Похожие категории</a></li>\n      <li if="{!isMulti}"><a data-toggle="tab" href="#group-edit-full-text">Полное описание</a></li>\n      <li class="{active: isMulti}" if="{app.config.version==&quot;5.3.1&quot;} "><a data-toggle="tab" href="#group-edit-images">Картинки</a></li>\n      <li><a data-toggle="tab" href="#group-edit-parameters-filters">Фильтры параметров</a></li>\n      <li><a data-toggle="tab" href="#group-edit-discounts">Скидки</a></li>\n      <li><a data-toggle="tab" href="#group-edit-seo">SEO</a></li>\n      <li><a data-toggle="tab" href="#group-edit-fields" if="{item.customFields}">Поля</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n\n        <div class="tab-pane fade {&quot;in active&quot;: !isMulti}" id="group-edit-home" show="{!isMulti}">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="picture" section="shopgroup" alt="0" size="256" value="{item.picture}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Наименование</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Родитель</label>\n                    <div class="input-group">\n                      <input class="form-control" name="nameGroup" value="{item.nameParent}" __readonly="{true}">\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{selectGroup}"><i class="fa fa-list text-primary"></i></div>\n                        <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">URL страницы</label>\n                    <input class="form-control" name="codeGr" type="text" value="{item.codeGr}">\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Группа модификаций по умолчанию</label>\n                    <select class="form-control" name="idModificationGroupDef" value="{item.idModificationGroupDef}">\n                      <option value=""></option>\n                      <option each="{item.modificationsGroups}" value="{id}" __selected="{id == item.idModificationGroupDef}" no-reorder>{name}</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-3">\n                  <label class="hidden-xs">&nbsp;</label>\n                  <div class="checkbox">\n                    <label>\n                      <input name="active" type="checkbox" __checked="{item.active == &quot;Y&quot;}">Отображать на сайте\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <label class="hidden-xs">&nbsp;</label>\n                  <div class="checkbox">\n                    <label>\n                      <input name="discount" type="checkbox" __checked="{item.discount == &quot;Y&quot;}">Предоставлять скидку\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Порядок вывода</label>\n                    <input class="form-control" name="position" step="1" value="{item.position}" type="{\'number\'}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Краткое описание</label>\n                <ckeditor name="commentary" value="{item.commentary}"></ckeditor>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Похожие группы</label>\n                <product-edit-additional-categories name="relatedGroups" value="{item.relatedGroups}"></product-edit-additional-categories>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label>Категория Яндекс.Маркет</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameMarketGroup" value="{item.nameMarketGroup}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectMarketGroup}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{removeMarketGroup}"><i class="fa fa-times text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n        </div>\n\n        <div class="tab-pane fade" id="group-edit-similar" show="{!isMulti}">\n          <catalog-static name="similar" rows="{item.similar}" cols="{similarCols}" add="{addChild}" reorder="true" dblclick="{openGroup}" remove="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="position">{parseInt(row.position) || 0}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n\n        <div class="tab-pane fade" id="group-edit-full-text" show="{!isMulti}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Полный текст</label>\n                <ckeditor name="footertext" value="{item.footertext}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class="tab-pane fade {&quot;in active&quot;: isMulti}" id="group-edit-images">\n          <product-edit-images name="images" value="{item.images}" section="shopgroup"></product-edit-images>\n        </div>\n        <div class="tab-pane fade" id="group-edit-parameters-filters">\n          <catalog-static name="parametersFilters" add="{addParametersFilters}" reorder="true" remove="true" cols="{parametersFiltersCols}" rows="{item.parametersFilters}" handlers="{parametersFiltersHandlers}">\n            <yield to="body">\n              <datatable-cell name="isActive"><i class="fa fa-fw {row.isActive ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i></datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="sortIndex">{row.sortIndex}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="group-edit-discounts">\n          <product-edit-discounts name="discounts" value="{item.discounts}"></product-edit-discounts>\n        </div>\n        <div class="tab-pane fade" id="group-edit-seo">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <button class="btn btn-primary btn-sm" each="{seoTags}" title="{note}" type="button" onclick="{seoTag.insert}" no-reorder>{name}</button>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Заголовок (title)</label>\n                <input class="form-control" name="title" type="text" onfocus="{seoTag.focus}" value="{item.title}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Ключевые слова (keywords)</label>\n                <input class="form-control" name="keywords" type="text" onfocus="{seoTag.focus}" value="{item.keywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Оглавление страницы (H1)</label>\n                <input class="form-control" name="pageTitle" type="text" onfocus="{seoTag.focus}" value="{item.pageTitle}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Описание (description)</label>\n                <textarea class="form-control" rows="5" name="description" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="group-edit-fields" if="{item.customFields}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;
self.edit = false;
self.app = app;
self.item = {};
self.loader = false;
self.error = false;
self.reloaded = false;
self.seoTags = [];

self.parametersFiltersCols = [{ name: 'isActive', value: '', width: '40px' }, { name: 'name', value: 'Наименование' }, { name: 'sortIndex', value: 'Индекс' }];

// шапка таблицы похожие категории
self.similarCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'position', value: 'Индекс' }];

self.seoTag = new app.insertText();

self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.rules = {
    name: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    if (name == 'name') self.reloaded = true;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

// отправить
self.submit = function (e) {
    var params = self.item;

    if (self.isMulti) {
        self.error = false;
        params = (0, _extends3.default)({ ids: self.multiIds }, self.item);
        if (params.commentary == '') params.commentary = null;
    } else {
        self.error = self.validation.validate(params, self.rules);
    }

    self.loader = true;

    if (!self.error) {
        self.loader = true;

        API.request({
            object: 'Category',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
                if (self.reloaded) observable.trigger('categories-reload', self.item);
            },
            complete: function complete() {
                self.loader = false;
                self.update();
            }
        });
    }
};

self.reload = function () {
    observable.trigger('categories-edit', self.item.id);
};

self.selectGroup = function (e) {
    var id = self.item.id;
    modals.create('group-select-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();

            if (items.length && items[0].id != self.item.id) {
                self.item.upid = items[0].id;
                self.item.nameParent = items[0].name;
                self.update();
                self.reloaded = true;
                this.modalHide();
            }
        }
    });
};

self.openGroup = function (e) {
    window.open('#products/categories/' + e.item.row.id, '_blank');
};

// добавление новой похожей категории
self.addChild = function () {
    modals.create('group-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.item.similar = self.item.similar || [];

            var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
            var ids = self.item.similar.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) self.item.similar.push(item);
            });

            self.update();
            this.modalHide();
        }
    });
};

self.addParametersFilters = function () {
    modals.create('filters-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        idGroup: self.item.id,
        submit: function submit() {
            self.item.parametersFilters = self.item.parametersFilters || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.item.parametersFilters.map(function (item) {
                return item.id;
            });
            var cods = self.item.parametersFilters.map(function (item) {
                return item.code;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1 || cods.indexOf(item.code) === -1) self.item.parametersFilters.push(item);
            });

            self.update();
            this.modalHide();
        }
    });
};

self.parametersFiltersHandlers = {
    toggleCheckbox: function toggleCheckbox(e) {
        this.row.isActive = !this.row.isActive;
    }
};

self.removeGroup = function (e) {
    self.item.upid = null;
    self.item.nameParent = '';
};

// Выбор Yandex группы
self.selectMarketGroup = function (e) {
    modals.create('mgroup-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
            self.item.marketCategory = items[0].id;
            self.item.nameMarketGroup = items[0].name;

            self.update();
            this.modalHide();
        }
    });
};

// Удалить группу market
self.removeMarketGroup = function (e) {
    self.item.marketCategory = 0;
    self.item.nameMarketGroup = '';
};

// получение наддых по редактируемой категории
observable.on('categories-edit', function (id) {
    self.item = {};
    self.isMulti = false;
    self.loader = true;
    self.error = false;
    self.update();

    parallel([function (callback) {
        var params = { id: id };

        API.request({
            object: 'Category',
            method: 'Info',
            data: params,
            success: function success(response) {
                self.item = response;
                callback(null, 'success');
            },
            error: function error(response) {
                self.item = {};
                callback('error', null);
            }
        });
    }, function (callback) {
        API.request({
            object: 'SeoVariable',
            method: 'Fetch',
            data: { type: 'goodsGroups' },
            success: function success(response) {
                self.seoTags = response.items;
                callback(null, 'success');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function (err, res) {
        self.loader = false;
        self.update();
    });
});

observable.on('categories-multi-edit', function (ids) {
    self.item = {};
    self.isMulti = true;
    self.error = false;
    self.multiIds = ids;
    self.update();
});

self.one('updated', function () {
    self.tags.similar.tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
        var _self$tags$similar$pa = self.tags.similar.pages,
            current = _self$tags$similar$pa.current,
            limit = _self$tags$similar$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.similar.value.splice(offset + newIndex, 0, self.tags.similar.value.splice(offset + oldIndex, 1)[0]);
        var temp = self.tags.similar.value;
        self.rows = [];
        self.update();
        self.tags.similar.value = temp;

        self.tags.similar.items.forEach(function (item, sort) {
            item.sortIndex = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'Category',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
    self.tags.parametersFilters.tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
        var _self$tags$similar$pa2 = self.tags.similar.pages,
            current = _self$tags$similar$pa2.current,
            limit = _self$tags$similar$pa2.limit;

        var offset = current > 0 ? (current - 1) * limit : 0;
        self.tags.parametersFilters.value.splice(offset + newIndex, 0, self.tags.parametersFilters.value.splice(offset + oldIndex, 1)[0]);
        var temp = self.tags.parametersFilters.value;
        self.rows = [];
        self.update();
        self.tags.parametersFilters.value = temp;

        self.tags.parametersFilters.items.forEach(function (item, sort) {
            item.sortIndex = sort + offset;
        });

        self.update();
    });
});

self.on('update', function () {
    localStorage.setItem('SE_section', 'shopgroup');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/groups/group-edit.tag